import React from 'react';
import { FieldError, FieldValues, useController, UseControllerProps } from 'react-hook-form';
import {
  Dropdown as BuildersDropdown,
  Label,
  ValidationMessage,
} from '@gjensidige/builders-components';

interface Option {
  label: string;
  value: string;
}

type DropdownProps<T extends FieldValues> = {
  labelText: string;
  placeholder: string;
  options: Option[];
  error: FieldError | undefined;
} & UseControllerProps<T> &
  Omit<React.ComponentProps<typeof BuildersDropdown>, 'onChange' | 'options'>;

const Dropdown = <T extends FieldValues>({
  name,
  control,
  labelText,
  error,
  ...props
}: DropdownProps<T>) => {
  const {
    field: { onChange, value },
  } = useController({ name, control });
  const showValidationMessage = error !== undefined;
  const handleOnChange = (option: Option) => {
    onChange(option?.value);
  };
  return (
    <>
      <Label htmlFor={name}>{labelText}</Label>
      <BuildersDropdown
        id={name}
        value={value}
        onChange={(option) => handleOnChange(option as Option)}
        tracking={false}
        {...props}
      />
      <ValidationMessage id={name} hidden={!showValidationMessage} invalid={showValidationMessage}>
        {error?.message}
      </ValidationMessage>
    </>
  );
};

export default Dropdown;
